export { SocialLinks } from './SocialLinks'
export type { SocialName, SocialItem } from './SocialLinks'
